export default __webpack_public_path__ + "static/media/CountPage1.08374ec2.txt";